module.exports = __webpack_public_path__ + "ionicons.621bd386841f74e0053c.svg";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/ionicons.svg?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons.svg?v=2.0.0
// module chunks = styles